// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G8U-U","content":"styles_content__13gHL","row":"styles_row__3fOpk","footer":"styles_footer__2F-ld","phraseLength":"styles_phraseLength__1gYBM"};